import React, { useContext, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { Logout, Search } from '@mui/icons-material';
import { Avatar, ListItemIcon, Menu, MenuItem } from '@mui/material';

import { logout } from '../../../../actions/security';
import logoSokojWhite from '../../../../assets/images/sokoj-logo.png';
import { locationPath } from '../../../../constants/app-routes';
import AuthContext from '../../../../context/auth_context';
import { navigationActions } from '../../../../reducers/navigation.js';
import { getUserNameAndSurname } from '../../../../utils.js';
import withTranslations from '../../../../utils/HighOrderComponent';
import HistoryLoginModal from '../../../Security/HistoryLogin/HistoryLoginModal';
import MenuSearch from '../../NavBar/NavRight/MenuSearch';

const NavRight = (props) => {
  const { loggedUser, validToken, allowedActions } = useContext(AuthContext);

  const { collapseMenu } = useSelector((state) => state.navigationReducer);
  const dispatch = useDispatch();
  const history = useHistory();
  const { gt, t } = props || {},
    { Tooltips, Header } = gt || {},
    { Login } = t || {},
    { NotificationMessages } = Login || {};

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSearchBox, setOpenSearchBox] = useState(false);
  const openMenu = Boolean(anchorEl);

  const userFullName = useMemo(
    () => getUserNameAndSurname(loggedUser),
    [loggedUser]
  );

  const logoutHandler = () => {
    dispatch(logout(history, NotificationMessages?.passwordExpiration));
  };

  const onModalCloseHandler = () => {
    setOpen(false);
  };

  const onSubmitHandler = (event) => {
    event?.preventDefault();
    onModalCloseHandler();
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const onToggleNavigationHandler = () => {
    dispatch(navigationActions.collapseMenu());
  };

  const stringAvatar = () => {
    let initials = '';

    if (userFullName?.length > 0) {
      const namesArray = userFullName.trim().split(' ');

      for (let i = 0; i < namesArray.length; i++) {
        initials += namesArray[i][0];
      }
    }

    return {
      children: initials,
    };
  };

  let toggleClass = ['mobile-menu'];
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  return (
    <div className="header-container">
      <div className="content-top">
        {validToken && (
          <div className="navbar-header">
            <div className="header-menu-left-item">
              <div className="m-header">
                <div
                  className={toggleClass.join(' ')}
                  id="mobile-collapse1"
                  role="button"
                  onClick={onToggleNavigationHandler}
                >
                  <span />
                </div>
              </div>
              <h2 className="info-page-welcome">{Header.appName}</h2>
              <div
                className={`search-input-header ${openSearchBox ? 'active' : ''}`}
              >
                <MenuSearch
                  allowedActions={allowedActions}
                  t={t.menu_items}
                  gt={gt}
                  collapseMenu={collapseMenu}
                />
              </div>
            </div>
            <div className="header-menu-center-item">
              <Link to={locationPath.DASHBOARD}>
                <img
                  src={logoSokojWhite}
                  className="img-fluid logo-image-header"
                  alt="logo"
                />
              </Link>
            </div>
            <div className="header-menu-right-item">
              <div className="header-menu-right-item-icons">
                <Search onClick={() => setOpenSearchBox(!openSearchBox)} />
              </div>
              <div className="header-menu-right-item-settings">
                <div className="header-menu-items-content">
                  <div
                    id="basic-button"
                    aria-controls={openMenu ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : undefined}
                    onClick={handleMenuClick}
                  >
                    <div className="header-menu-items-holder">
                      <div className="header-menu-items-icon-holder">
                        <Avatar {...stringAvatar()} />
                      </div>
                      <div className="header-menu-items-name-holder">
                        <div className="header-menu-items-content-fullname">
                          {userFullName}
                        </div>
                        <div className="header-menu-items-content-email">
                          {loggedUser.username}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={openMenu}
                    onClose={handleCloseMenu}
                    onClick={handleCloseMenu}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <h6 className="dropdown-header dropdown-header-welcome-info">
                      {userFullName}
                    </h6>
                    <MenuItem onClick={logoutHandler}>
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      {Tooltips.logout}
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </div>
            {/* <div className="header-menu-items d-flex flex-row justify-content-end">
            //TODO vratiti prevode u nekom trenutku
            <div className="header-menu-items-icons d-flex align-items-center">
              <ul className="navbar-nav d-flex flex-row justify-content-end align-items-center">
                <li>
                  <LanguagePicker />
                </li>
                <li>
                  <Tooltip
                    title={Tooltips.historyLogin}
                    placement="bottom"
                    arrow={true}
                  >
                    <span role="button" onClick={historyLoginClickHandler}>
                      <Icon baseClassName="fa-solid fa-clock-rotate-left history-icon" />
                    </span>
                  </Tooltip>
                </li>
              </ul>
            </div>
            
          </div> */}
          </div>
        )}
      </div>
      {open && (
        <HistoryLoginModal
          show={open}
          onSubmitHandler={onSubmitHandler}
          hideModal={onModalCloseHandler}
        />
      )}
      <div className="vertical-overlay"></div>
    </div>
  );
};

export default withTranslations(NavRight, ['menu_items', 'Login', 'Global']);
